import { createSelector } from "reselect";
import _ from "lodash";
const createSelectors = parentReducer => {
    return new class {
        selectReportTitles = store => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["JobPackSelectReportsWidget_reducer"];
            return reducer.reportTitles;
        };
        selectSSWPConfigs = store => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["JobPackSelectReportsWidget_reducer"];
            return reducer.sswpConfigs;
        };
        selectHSQEConfigs = store => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["JobPackSelectReportsWidget_reducer"];
            return reducer.hsqeConfigs;
        };
        
        templateList = createSelector(
            [this.selectHSQEConfigs],(templates) => {
                let finalResult = []
                Object.values(templates).map((e)=>{
                    if(e.profile.deleted === false){
                        finalResult.push(e.profile.report_title)
                        return null
                    }
                    return null;
                })
                return finalResult;
            }
            );
        selectSSWPConfigInfo = createSelector(
            [this.selectSSWPConfigs],
            (configs = false) => {
                if (configs) {
                    let configInfo = Object.keys(configs).map(e => {
                        let uid = e;
                        let name = _.get(configs[e], "template_name") || "N/A";
                        return { uid, name };
                    });
                    return configInfo;
                } else {
                    return false;
                }
            }
        );
    }();
};
export default createSelectors;
